export const recipeStatuses = {
  draft: {
    gray: true,
    name: 'Draft',
  },
  inProgress: {
    orange: true,
    name: 'In Progress',
  },
  inTest: {
    blue: true,
    name: 'In Test',
  },
  live: {
    green: true,
    name: 'Live',
    adminOnly: true,
  },
}

export const recipeDifficulties = {
  easy: {
    name: 'Easy',
  },
  moderate: {
    name: 'Moderate',
  },
  challenging: {
    name: 'Challenging',
  },
}

export const servings = [1,2,3,4,5,6,7,8]


export const convertServings = (servings = []) => {
  const groups = []
  const sorted = servings.sort()

  let lastIndex = 0
  for (let i = 0; i < sorted.length; i++) {
    if(sorted[i] + 1 !== sorted[i + 1]) {
      groups.push({
        start: sorted[lastIndex],
        end: sorted[i],
      })
      lastIndex = i + 1
    }
  }

  return groups.map(group => {
    if (group.start === group.end) {
      return group.start
    } else {
      return `${group.start}-${group.end}`
    }
  }).join(', ')
}

export const defaultRecipe = {
  name: '',
  status: 'draft',
  servings: [4],
  description: {},
  title: {},
  difficulty: 'easy',
  tagIds: [],
  availableRegions: [],
}

// list of required fields by status
//if status is not that then all mandatory fields are required by default
export const requiredByStatus = {
  draft: ['name', 'title', 'description', 'image'],
}
